import GameControl from "./GameControl";


export default GameControl;